<template>
  <div
    class="bg-float-default-low shadow-short focus-visible-outline-default-hi rounded-lg relative block h-320 min-h-[13rem] w-full no-underline motion-safe:transition motion-safe:duration-200 motion-safe:ease-in sm:min-h-[13.5rem]"
  >
    <div
      class="flex h-full flex-col items-center justify-between p-16 md:p-24 md:pt-32"
    >
      <picture
        class="m-auto flex max-h-full min-h-0 w-full max-w-320 justify-center"
      >
        <RevIllustrationSource
          v-if="image?.srcMobile"
          :height="image?.heightMobile || image?.height"
          media="(max-width: 480px)"
          :src="image?.srcMobile"
          :width="image?.widthMobile || image?.width"
        />

        <RevIllustration
          :alt="image?.alt"
          class="block object-contain"
          :height="image?.height"
          :src="image?.src"
          :width="image?.width"
        />
      </picture>
      <div class="self-stretch text-center md:text-left">
        <p class="text-static-default-hi body-1 mt-32 sm:mt-12 md:mt-24">
          {{ title }}
        </p>

        <span
          v-if="tagline"
          class="text-static-default-low body-2 hidden md:mt-4 md:block"
        >
          {{ tagline }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Category } from '@backmarket/http-api/src/api-specs-content/models/categories'
import { RevIllustration } from '@ds/components/Illustration'
import { RevIllustrationSource } from '@ds/components/IllustrationSource'

defineProps<Category>()
</script>
